import FlexContainer from 'components/common/FlexContainer';
import { fontStyles } from 'styles/theme';
import { mobileMediaQuery } from 'utils/common';
import styled from '@emotion/styled';

export const NavContainer = styled(FlexContainer)({
  gap: 16,
  [mobileMediaQuery]: {
    margin: '0px 16px',
  },
});

export const Heading = styled.span({
  fontSize: fontStyles.sizes.xl,
  [mobileMediaQuery]: {
    padding: '0px 20px',
  },
});

export const SwitchContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center',
  gap: 8,
  [mobileMediaQuery]: {
    gap: 4,
  },
});

export const Container = styled(FlexContainer)({
  margin: '80px 12%',
  gap: 32,
  [mobileMediaQuery]: {
    margin: '32px 0px 80px',
  },
});
